import { userLanguage, ValidLanguages } from '$translations/index';
import { EditPositionDto } from '$types/serverTypes/editPositionDto';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  DuplicatePositionEmployerOutput,
} from '../companies.types';

export const duplicatePositionEmployer = (builder: CompanyBuilder) =>
  builder.mutation<
    DuplicatePositionEmployerOutput,
    { position: EditPositionDto }
  >({
    query: ({ position }) => {
      const cleanedPosition: any = { ...position };
      cleanedPosition.DuplicateRoster = false;

      cleanedPosition.positionSkills = [
        ...(position.RequiredSkills?.map(
          ({ Id, Title }: { Id: number; Title: string }) => ({
            positionsId: position.JobPosition?.Id,
            skillId: Id,
            IsRequired: true,
            skill: { Id, Title, Deprecated: false },
          })
        ) || []),
        ...(position.NiceToHaveSkills?.map(
          ({ Id, Title }: { Id: number; Title: string }) => ({
            positionsId: position.JobPosition?.Id,
            skillId: Id,
            IsRequired: false,
            skill: { Id, Title, Deprecated: false },
          })
        ) || []),
      ];

      cleanedPosition.CustomJobTitle = position.CustomJobTitle
        ? position.CustomJobTitle
        : null;

      // just for fallback
      // @ts-ignore
      cleanedPosition.Skills_position = [
        ...(position.RequiredSkills || []),
        ...(position.NiceToHaveSkills || []),
      ];

      // Delete unneccesary props
      delete cleanedPosition.RequiredSkills;
      delete cleanedPosition.NiceToHaveSkills;
      return {
        url: '/positions/duplicate',
        method: 'POST',
        body: cleanedPosition,
      };
    },
    transformResponse: (queryResponse: DuplicatePositionEmployerOutput) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.POSITION_DUPLICATED
          : SuccessMessageEn.POSITION_DUPLICATED,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[duplicatePositionEmployer]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.PositionDuplicateError
          : ErrorMessageEn.PositionDuplicateError,
        error,
        true
      );
    },
    invalidatesTags: () => [{ type: 'Company' }],
  });
